import { render, staticRenderFns } from "./ItemShowModal.vue?vue&type=template&id=34f5cd61&scoped=true"
import script from "./ItemShowModal.vue?vue&type=script&lang=js"
export * from "./ItemShowModal.vue?vue&type=script&lang=js"
import style0 from "./ItemShowModal.vue?vue&type=style&index=0&id=34f5cd61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5cd61",
  null
  
)

export default component.exports